import { configureStore } from "@reduxjs/toolkit";
import rootActions from "../actions";
import { loansActionSlice } from "../actions/loans.actions";
import { authzActionSlice } from "../actions/authz.action";
import { reportActionSlice } from "../actions/report.action";
import { idLookupActionSlice } from "../actions/id-lookup.action";
import { policySimulationActionSlice } from "../actions/policy-simulation.action";
import { Env, env } from "../config";
import AdminStateReducer from "../reducers/admin.reducer";
import AgreementStateReducer from "../reducers/agreement.reducer";
import ApplicationStateReducer from "../reducers/application.reducer";
import EmployerStateReducer from "../reducers/employer.reducer";
import EnterpriseStateReducer from "../reducers/enterprise.reducer";
import InvoiceStateReducer from "../reducers/invoice.reducer";
import LenderStateReducer from "../reducers/lender.reducer";
import LoanStateReducer from "../reducers/loan.reducer";
import LoginStateReducer from "../reducers/login.reducer";
import ProductStateReducer from "../reducers/product.reducer";
import RefundsReducer from "../reducers/refunds.reducer";
import SessionStateReducer from "../reducers/session.reducer";
import UIStateReducer from "../reducers/ui.reducer";
import UserWorkInfoReducer from "../reducers/user-work-info.reducer";
import UserStateReducer from "../reducers/user.reducer";

export const store = configureStore({
  reducer: {
    ui: UIStateReducer,
    login: LoginStateReducer,
    admin: AdminStateReducer,
    user: UserStateReducer,
    enterprise: EnterpriseStateReducer,
    application: ApplicationStateReducer,
    loan: LoanStateReducer,
    product: ProductStateReducer,
    agreeement: AgreementStateReducer,
    invoice: InvoiceStateReducer,
    refunds: RefundsReducer,
    session: SessionStateReducer,
    lender: LenderStateReducer,
    userWorkInfo: UserWorkInfoReducer,
    employer: EmployerStateReducer,
    [reportActionSlice.reducerPath]: reportActionSlice.reducer,
    [loansActionSlice.reducerPath]: loansActionSlice.reducer,
    [authzActionSlice.reducerPath]: authzActionSlice.reducer,
    [idLookupActionSlice.reducerPath]: idLookupActionSlice.reducer,
    [policySimulationActionSlice.reducerPath]:
      policySimulationActionSlice.reducer,
  },
  devTools: env !== Env.PROD,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rootActions),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
